import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { NormasTeachingProductDTO } from "./useNormasTeachingProductById.ts";

/** Stable identity: a fresh `[]` per render would churn every memo built on it. */
const NO_PRODUCTS: NormasTeachingProductDTO[] = [];

export function useAllNormasTeachingProducts({
  search,
  enabled = true,
}: { search?: string; enabled?: boolean } = {}) {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const { data, error, isLoading } = useSWR(
    enabled ? [`/products`, search] : null,
    async ([url]) => {
      const { data } = await createAxiosInstance().get<{
        products: NormasTeachingProductDTO[];
      }>(url, { params: { ...(search && { search }) } });

      return data;
    },
    { keepPreviousData: true },
  );

  return {
    products: data?.products ?? NO_PRODUCTS,
    error,
    isLoading: isLoading && data === undefined,
  };
}
